'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Organisationseinheit = require('../entity').Organisationseinheit;

module.exports = function (connection) {
  return {
    byKostenstelleEquals: function byKostenstelleEquals(kostenstelle, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byKostenstelleEquals', 'kostenstelle')(kostenstelle, additionalParams);
    },
    byKostenstelleLike: function byKostenstelleLike(kostenstelle, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byKostenstelleLike', 'kostenstelle')(kostenstelle, additionalParams);
    },
    byKostenstellenpfadEquals: function byKostenstellenpfadEquals(kostenstellenpfad, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byKostenstellenpfadEquals', 'kostenstellenpfad')(kostenstellenpfad, additionalParams);
    },
    byKostenstellenpfadLike: function byKostenstellenpfadLike(kostenstellenpfad, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byKostenstellenpfadLike', 'kostenstellenpfad')(kostenstellenpfad, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byNameLike', 'name')(name, additionalParams);
    },
    byObsoletEquals: function byObsoletEquals(obsolet, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byObsoletEquals', 'obsolet')(obsolet, additionalParams);
    },
    byParentOrgaNameEquals: function byParentOrgaNameEquals(parentorganame, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byParentOrgaNameEquals', 'parentorganame')(parentorganame, additionalParams);
    },
    byParentOrgaNameLike: function byParentOrgaNameLike(parentorganame, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byParentOrgaNameLike', 'parentorganame')(parentorganame, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    bySearchRepLikeUnrestricted: function bySearchRepLikeUnrestricted(rep, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'bySearchRepLikeUnrestricted', 'rep')(rep, additionalParams);
    },
    byUeberOrganisationseinheitEquals: function byUeberOrganisationseinheitEquals(ueberorganisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byUeberOrganisationseinheitEquals', 'ueberorganisationseinheit')(ueberorganisationseinheit, additionalParams);
    },
    byUeberOrganisationseinheitIsNull: function byUeberOrganisationseinheitIsNull(page, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'byUeberOrganisationseinheitIsNull', 'page')(page, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'findAll', 'page')(page, additionalParams);
    },
    findAllUnrestricted: function findAllUnrestricted(projection, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'findAllUnrestricted', 'projection')(projection, additionalParams);
    },
    byPubmanID: function byPubmanID(pubmanid, additionalParams) {
      return templates.searchTemplate(connection)(Organisationseinheit, 'findByPubmanID', 'pubmanid')(pubmanid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Organisationseinheit, 'genericand')(searchParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(Organisationseinheit, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('organisationseinheit')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/organisationseinheit.js
// module id = mBt2
// module chunks = 0